/**
 * Registry of all dynamic configs used in the application.
 * To add a new config, add an entry to this map.
 */
export const CONFIGS: Record<string, DynamicConfigOptions> = {
  REVUP_CAMPAIGN: {
    configName: "revupguids",
    fallback: {
      REV_UP_CAMPAIGN_GUIDs: [],
      REV_UP_CAMPAIGN_START: "",
      REV_UP_CAMPAIGN_END: "",
    },
  },
  SJC_OUTAGE: {
    configName: "sjc_outage",
    fallback: {
      SJC_OUTAGE_GUIDs: [],
      SJC_OUTAGE_START: "",
      SJC_OUTAGE_END: "",
    },
  },
};

export interface DynamicConfigOptions {
  configName: string;
  fallback: Record<string, unknown>;
}

export type ConfigKey = keyof typeof CONFIGS;
